import dayjs from "dayjs"

import { DATE_FORMAT } from "../../../../../../utils/date/date.ts"

interface LogDatePreset {
  key: string
  label: string
  /** Computed fresh on every read — "Today" must never go stale between renders. */
  range: () => [string, string]
}

const day = (offset = 0) => dayjs().add(offset, "day").format(DATE_FORMAT)

const LOG_DATE_PRESETS: LogDatePreset[] = [
  { key: "today", label: "Today", range: () => [day(), day()] },
  { key: "yesterday", label: "Yesterday", range: () => [day(-1), day(-1)] },
  {
    key: "thisWeek",
    label: "This Week",
    range: () => [
      dayjs().startOf("week").format(DATE_FORMAT),
      dayjs().endOf("week").format(DATE_FORMAT)
    ]
  },
  {
    key: "lastWeek",
    label: "Last Week",
    range: () => [
      dayjs().subtract(1, "week").startOf("week").format(DATE_FORMAT),
      dayjs().subtract(1, "week").endOf("week").format(DATE_FORMAT)
    ]
  },
  {
    key: "thisMonth",
    label: "This Month",
    range: () => [
      dayjs().startOf("month").format(DATE_FORMAT),
      dayjs().endOf("month").format(DATE_FORMAT)
    ]
  },
  {
    key: "lastMonth",
    label: "Last Month",
    range: () => [
      dayjs().subtract(1, "month").startOf("month").format(DATE_FORMAT),
      dayjs().subtract(1, "month").endOf("month").format(DATE_FORMAT)
    ]
  },
  { key: "last30Days", label: "Last 30 Days", range: () => [day(-29), day()] }
]

/** `null` means the current range is either unset or a genuine custom pick. */
const matchLogDatePreset = (
  after: string | null,
  before: string | null
): string | null => {
  if (!after || !before) return null
  return (
    LOG_DATE_PRESETS.find((preset) => {
      const [start, end] = preset.range()
      return start === after && end === before
    })?.key ?? null
  )
}

export { LOG_DATE_PRESETS, matchLogDatePreset }
